import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import ShowsPage from "@/pages/ShowsPage";
import ReservationsPage from "@/pages/ReservationsPage";
import KassaPage from "@/pages/KassaPage";
import AbschlussPage from "@/pages/AbschlussPage";
import SeasonPage from "@/pages/SeasonPage";
import { Toaster } from "sonner";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><ShowsPage /></ProtectedRoute>} />
          <Route path="/shows/:showId/reservations" element={<ProtectedRoute><ReservationsPage /></ProtectedRoute>} />
          <Route path="/shows/:showId/kassa" element={<ProtectedRoute><KassaPage /></ProtectedRoute>} />
          <Route path="/shows/:showId/abschluss" element={<ProtectedRoute><AbschlussPage /></ProtectedRoute>} />
          <Route path="/season" element={<ProtectedRoute><SeasonPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors />
    </AuthProvider>
  );
}
